import { BaseApp } from 'marketplace-storefront-base/containers/BaseApp';
import { debug } from 'marketplace-storefront-base/utils/env';
import { getPublicRootUrl, getShortlinkUrl } from 'marketplace-storefront-base/utils/urls';
import MarketingNav from 'marketplace-ui-common/components/MarketingNav';
import LegacyUnifiedApp from 'marketplace-unified-public-base/containers/App';
import { useEffect, useMemo, useState } from 'react';
import { isHubSpotEmail } from './isHubSpotEmail';
import { jsx as _jsx } from "react/jsx-runtime";
function getLoginUrl(location) {
  const {
    pathname,
    search
  } = location;
  return `${getShortlinkUrl()}${pathname}${search}`;
}
function isHealthCheck() {
  return window.location.search.includes('_healthCheck');
}
export function PublicApp({
  history,
  publicAuth,
  usageTracker
}) {
  const [location, setLocation] = useState(history.location);
  const marketingNavLocation = useMemo(() => ({
    pathname: `${getPublicRootUrl()}${location.pathname}`,
    search: location.search
  }), [location.pathname, location.search]);
  const isUngated = useMemo(() => {
    return isHubSpotEmail((publicAuth === null || publicAuth === void 0 ? void 0 : publicAuth.email) || '') && (debug() || isHealthCheck());
  }, [publicAuth]);
  useEffect(() => {
    const unlisten = history.listen(nextLocation => {
      setLocation(nextLocation);
    });
    return () => {
      unlisten();
    };
  }, [history]);
  if (!isUngated) {
    return /*#__PURE__*/_jsx(LegacyUnifiedApp, {});
  }
  return /*#__PURE__*/_jsx(MarketingNav, {
    location: marketingNavLocation,
    loginUrl: getLoginUrl(location),
    children: /*#__PURE__*/_jsx(BaseApp, {
      appContext: "public",
      history: history,
      usageTracker: usageTracker
    })
  });
}